/**
 * @description: 商品赠送汇总报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="gsr-szh-report">
        <div class="szh-list">
            <p class="p-hint">注：赠送总量和赠送金额已扣除退款商品和退款金额</p>
            <div class="row row-margin">
                <label class="list-label-2">时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="szhTime">
                        <input type="text" class="form-control laydate-icon" v-model="szhStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="szhEndTime">
                    </div>
                </div>
                <label class="list-label-4">消费门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="szhShop" data-placeholder="请选择消费门店"></select>
                </div>
                <label class="list-label-4">商品类型:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择商品类型" v-model="gtype_txt" ref="gtype_txt" @click="gtypeFun($event)" readonly>
                    <span class="selection-clear" @click="clear_input('gtype_txt')">×</span>
                    <span class="span-arrow" role="presentation"><b></b></span>
                </div>
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="szh_goods_name">
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-3" v-show="szh_type == '1'">赠送人:</label>
                <div class="col-md-2 ct-col" v-show="szh_type == '1'">
                    <select class="form-control" ref="szh_admin" data-placeholder="请选择赠送人"></select>
                </div>
                <label class="list-label-2">组别:</label>
                <div class="col-md-2">
                    <input class="form-control input-readonly" placeholder="请选择组别" v-model="szh_group_txt" ref="szh_group_txt" readonly @click="szhEnterGroup">
                    <span class="selection-clear" @click="clear_input('szh_group_txt')">×</span>
                    <span class="span-arrow"><b></b></span>
                </div>
            </div>
            <div class="row">
                <label class="list-label-4">赠送总量:</label>
                <div class="list-total" ref="szh_total_num"></div>
                <label class="list-label-4">赠送总额:</label>
                <div class="list-total" ref="szh_total_amount"></div>
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitSzhTable">查询</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getSzhExportSet">导出</button>
                    <button type="button" class="szh-man btn btn-flat btn-border-gray btn-orange" @click="szhListType(1)">按赠送人统计</button>
                    <button type="button" class="szh-cmdy btn btn-flat btn-border-gray" @click="szhListType(2)">按赠送商品统计</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="szh_list"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="szhExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix" v-show="szh_type == '1'">
                        <li>
                            <input type='checkbox' v-model='szhExport_allcheck1' @click='szhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="admin_name">
                            <label>赠送人</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="actual_amount">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="total_amount">
                            <label>赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="quantity">
                            <label>赠送数量</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="buying_price">
                            <label>进货单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel1' value="buying_price_total">
                            <label>进货价总额</label>
                        </li>
                    </ul>
                    <ul class="set-area clearfix" v-show="szh_type == '2'">
                        <li>
                            <input type='checkbox' v-model='szhExport_allcheck2' @click='szhExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="goods_type_name">
                            <label>商品类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="actual_amount">
                            <label>销售单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="total_amount">
                            <label>赠送金额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='szhExport_checkModel2' value="quantity">
                            <label>赠送数量</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix" v-show="szh_type == '1'">
                        <li>
                            <input type="radio" v-model='szhExport_type1' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='szhExport_type1' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                    <ul class="clearfix" v-show="szh_type == '2'">
                        <li>
                            <input type="radio" v-model='szhExport_type2' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='szhExport_type2' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 组别列表 -->
        <div class="szh-group">
            <h3>请选择组别</h3>
            <div class="group-search pull-right">
                <input type="text" placeholder="请输入组别名称" v-model="szh_group_name">
                <img src="../../../assets/images/group_search.png" @click="getSzhGroupData">
            </div>
            <!-- 列表 -->
            <div class="group-list">
                <ul class="clearfix">
                    <li>
                        <input type='checkbox' v-model='szh_group_allcheck' @click='groupSzhCheckedAll'>
                        <label>全部组别</label>
                    </li>
                    <li v-for="item in szh_group_checkboxData" :key="item.group_id">
                        <input type="checkbox" v-model='szh_group_checkboxModel' :value='item.group_id'>
                        <label>{{item.group_name}}</label>
                    </li>
                </ul>
            </div>
            <div class="row">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="szhGroupBack()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="szhGroupSub()">确定</button>
            </div>
        </div>
        <!-- 商品类型弹窗 -->
        <div class="ele-hide" ref="gtype_area">
            <div class="set-export sel-seldiv">
                <ul class="set-area clearfix">
                    <li>
                        <input type='checkbox' v-model='gtype_all' @click='gtypeAll'>
                        <label>全选</label>
                    </li>
                    <li v-for="item in gtype_data" :key="item.id">
                        <input type="checkbox" v-model='gtype_item' :value="item.id">
                        <label>{{item.name}}</label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                szhStartTime: "",
                szhEndTime: "",
                szh_goods_name: "",
                szh_group_txt: "",
                szh_group_allcheck: false,
                szh_c_group_allcheck: false,
                szh_group_checkboxModel: [],
                c_szh_group_checkboxModel: [],
                szh_group_checkboxData: [],
                szh_group_name: '',
                gtype_txt: '',
                gtype_all: false,
                c_gtype_all: false,
                gtype_data: [],
                gtype_item: [],
                szh_type: 1,
                szhExport_allcheck1: false,
                c_szhExport_allcheck1: false,
                szhExport_allcheck2: false,
                c_szhExport_allcheck2: false,
                szhExport_checkModel1: [],
                szhExport_checkModel2: [],
                szhExport_checkData1: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'admin_name', 'actual_amount', 'total_amount', 'quantity', 'buying_price', 'buying_price_total'],
                szhExport_checkData2: ['shop_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'actual_amount', 'total_amount', 'quantity', 'buying_price', 'buying_price_total'],
                szhExport_type1: 1,
                szhExport_type2: 1,
            }
        },
        watch: {
            gtype_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.gtype_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.gtype_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            gtype_item: {
                handler: function (val, oldVal) {
                    if(this.gtype_item.length >= this.gtype_data.length) {
                        this.gtype_all = true;
                        this.c_gtype_all = true;
                    } else {
                        this.gtype_all = false;
                        this.c_gtype_all = false;
                    }
                },
                deep: true
            },
            szh_group_txt: {
                handler: function(val,oldval) {
                    if(val != "") {
                        $(this.$refs.szh_group_txt).parent().find('.selection-clear').show();
                    } else {
                        $(this.$refs.szh_group_txt).parent().find('.selection-clear').hide();
                    }
                },
                deep: true
            },
            szh_group_checkboxModel: {
                handler: function(val, oldVal) {
                    if(this.szh_group_checkboxModel.length >= this.szh_group_checkboxData.length) {
                        this.szh_group_allcheck = true;
                        this.szh_c_group_allcheck = true;
                    } else {
                        this.szh_group_allcheck = false;
                        this.szh_c_group_allcheck = false;
                    }
                },
                deep: true
            },
            szhExport_checkModel1: {
                handler: function(val, oldVal) {
                    if(this.szhExport_checkModel1.length >= this.szhExport_checkData1.length) {
                        this.szhExport_allcheck1 = true;
                        this.c_szhExport_allcheck1 = true;
                    } else {
                        this.szhExport_allcheck1 = false;
                        this.c_szhExport_allcheck1 = false;
                    }
                },
                deep: true
            },
            szhExport_checkModel2: {
                handler: function(val, oldVal) {
                    if(this.szhExport_checkModel2.length >= this.szhExport_checkData2.length) {
                        this.szhExport_allcheck2 = true;
                        this.c_szhExport_allcheck2 = true;
                    } else {
                        this.szhExport_allcheck2 = false;
                        this.c_szhExport_allcheck2 = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.szhStartTime = moment().format('YYYY-MM-DD 08:00');
            this.szhEndTime = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            this.shopDatas = [];
            this.innitInput();  // 门店
            this.getGoodsType();  // 商品类型
            this.getSzhAdmin();  // 赠送人
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.szhStartTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.szhEndTime = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.szhStartTime = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.szhEndTime = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.szhTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit : {
                        days : 31
                    },
                }, function(start, end, label) {
                    _this.szhStartTime = start.format('YYYY-MM-DD 08:00');
                    _this.szhEndTime = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            innitInput: function(shop_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.szhShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id);
                            });
                            $(_this.$refs.szhShop).val(data.response.result[1].id).trigger('change');
                            _this.setShopDefaultTime(data.response.result[1].id);
                            _this.innitSzhTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 商品类型
            getGoodsType: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "show_room_pack": -1
                        }
                    },
                    "comment": []
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getAllGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.gtype_data = data.response.result.data
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },



            // 获取赠送人数据
            getSzhAdmin: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "User/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let szhAdmDatas = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result']['user_info'], function(k, v) {
                                szhAdmDatas.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.szh_admin).select2({
                                data: szhAdmDatas,
                                language: "zh-CN",
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 商品类型弹窗
            gtypeFun: function(e) {
                let _this = this;
                let c_gtype_item = _this.gtype_item;
                layer.confirm('', {
                    skin: 'timing_room_type',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['商品类型', true],
                    area: ['660px', ''], // 宽高
                    content: $(_this.$refs.gtype_area),
                    cancel: function() {
                        // 右上角关闭
                        _this.gtype_item = c_gtype_item;
                    }
                }, function() {
                    let texts = [];
                    _this.gtype_data.forEach(function(item) {
                        _this.gtype_item.forEach(function(item2) {
                            if(item.id == item2) {
                                texts.push(item.name);
                            }
                        });
                    });
                    _this.gtype_txt = texts.join(",");
                    layer.closeAll();
                }, function() {
                    _this.gtype_item = c_gtype_item;
                });
            },

            // 全选
            gtypeAll: function() {
                let _this = this;
                _this.gtype_all = _this.c_gtype_all;
                if(!_this.gtype_all) { // 实现全选
                    _this.gtype_item = [];
                    _this.gtype_data.forEach(function(item) {
                        _this.gtype_item.push(item.id);
                    });
                } else { // 实现反选
                    _this.gtype_item = [];
                }
            },

            // 进入选择组别
            szhEnterGroup: function() {
                this.c_szh_group_checkboxModel = this.szh_group_checkboxModel;
                this.szh_group_checkboxModel = [];
                this.getSzhGroupData();
                this.szh_group_checkboxModel = this.c_szh_group_checkboxModel;
                $('.szh-list').hide();
                $('.szh-group').show();
            },
            // 获取组别列表
            getSzhGroupData: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": '0',
                            "page_size": '0',
                            "shop_id": $(_this.$refs.szhShop).val(),
                            "key_word": 'user',
                            "group_name": _this.szh_group_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGroupSearchList",
                    crossDomain: true,
                    async: false,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            _this.szh_group_checkboxData = data.response.result;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 全选
            groupSzhCheckedAll: function() {
                let _this = this;
                _this.szh_group_allcheck = _this.szh_c_group_allcheck;
                if(!_this.szh_group_allcheck) { // 实现全选
                    _this.szh_group_checkboxModel = [];
                    _this.szh_group_checkboxData.forEach(function(item) {
                        _this.szh_group_checkboxModel.push(item.group_id);
                    });
                } else { // 实现反选
                    _this.szh_group_checkboxModel = [];
                }
            },
            // 返回
            szhGroupBack: function() {
                $('.szh-group').hide();
                $('.szh-list').show();
                this.szh_group_checkboxModel = this.c_szh_group_checkboxModel;
            },
            szhGroupSub: function() {
                let _this = this;
                let arr = [];
                _this.szh_group_checkboxData.forEach(function(item) {
                    _this.szh_group_checkboxModel.forEach(function(sub) {
                        if(item.group_id == sub) {
                            arr.push(item.group_name);
                        }
                    });
                });
                _this.szh_group_txt = arr.join(',');
                $('.szh-group').hide();
                $('.szh-list').show();
            },
            // 商品赠送汇总报表表格
            innitSzhTable: function() {
                let _this = this;
                $(_this.$refs.szh_list).bootstrapTable('destroy');
                $(_this.$refs.szh_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getSzhList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "13%"
                    }, {
                        field: "goods_type_name",
                        title: "商品类型",
                        width: "5%"
                    }, {
                        field: "goods_name",
                        title: "商品名称",
                        width: "13%"
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "5%"
                    }, {
                        field: "admin_name",
                        title: "赠送人",
                        width: "8%"
                    }, {
                        field: "actual_amount",
                        title: "销售单价",
                        width: "8%"
                    }, {
                        field: "total_amount",
                        title: "赠送金额",
                        width: "8%"
                    }, {
                        field: "quantity",
                        title: "赠送数量",
                        width: "8%"
                    }, {
                        field: "buying_price",
                        title: "进货单价",
                        width: "8%"
                    }, {
                        field: "buying_price_total",
                        title: "进货价总额",
                        width: "8%"
                    }]
                });
                $(_this.$refs.szh_list).on('load-success.bs.table', function(data) {
                    if(_this.szh_type == '2') {
                        $(_this.$refs.szh_list).bootstrapTable('hideColumn', 'admin_name');
                    }
                });
            },
            // 获取商品赠送汇总报表
            getSzhList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.szhShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "type": _this.szh_type,
                            "start_time": _this.szhStartTime,
                            "end_time": _this.szhEndTime,
                            "shop_id": shop_id,
                            "goods_type": _this.gtype_item,
                            "goods_name": _this.szh_goods_name,
                            "admin_id": $.trim($(_this.$refs.szh_admin).val()),
                            "user_group_id": _this.szh_group_checkboxModel,
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getGiftReport",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.szh_total_num).text(data.response.result.total_quantity);
                            $(_this.$refs.szh_total_amount).text(data.response.result.total_amount);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },

            // 清空多选
            clear_input: function(name) {
                if(name == 'gtype_txt') {
                    this.gtype_txt = "";
                    this.gtype_item = [];
                }else if(name == 'szh_group_txt') {
                    this.szh_group_txt = "";
                    this.szh_group_checkboxModel = [];
                } 
            },

            // 获取导出设置
            getSzhExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/giftReporttExport?type="+_this.szh_type
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                if(_this.szh_type == '1') {
                                    _this.szhExport_checkModel1 = data.response.result.export_fields;
                                    _this.szhExport_type1 = data.response.result.export_type;
                                } else if(_this.szh_type == '2') {
                                    _this.szhExport_checkModel2 = data.response.result.export_fields;
                                    _this.szhExport_type2 = data.response.result.export_type;
                                }
                            } else {
                                if(_this.szh_type == '1') {
                                    _this.szhExport_checkModel1 = _this.szhExport_checkData1;
                                    _this.szhExport_type1 = 1;
                                } else if(_this.szh_type == '2') {
                                    _this.szhExport_checkModel2 = _this.szhExport_checkData2;
                                    _this.szhExport_type2 = 1;
                                }
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.szhExport_alert)
                }, function() {
                    _this.exportSzhList();
                });
            },
            // 导出字段全选
            szhExportCheckedAll: function() {
                let _this = this;

                if(_this.szh_type == '1') {
                    _this.szhExport_allcheck1 = _this.c_szhExport_allcheck1;
                    if(!_this.szhExport_allcheck1) { // 实现全选
                        _this.szhExport_checkModel1 = [];
                        _this.szhExport_checkData1.forEach(function(item) {
                            _this.szhExport_checkModel1.push(item);
                        });
                    } else { // 实现反选
                        _this.szhExport_checkModel1 = [];
                    }
                } else if(_this.szh_type == '2') {
                    _this.szhExport_allcheck2 = _this.c_szhExport_allcheck2;
                    if(!_this.szhExport_allcheck2) { // 实现全选
                        _this.szhExport_checkModel2 = [];
                        _this.szhExport_checkData2.forEach(function(item) {
                            _this.szhExport_checkModel2.push(item);
                        });
                    } else { // 实现反选
                        _this.szhExport_checkModel2 = [];
                    }
                }
            },
            // 点击“导出”
            exportSzhList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.szhShop).val();

                if(_this.szh_type == '1') {
                    let export_fields = JSON.stringify(_this.szhExport_checkModel1);
                    window.location.href = Vue.ctUrl + "FinanceReport/giftReporttExport?" +
                        "type=" + _this.szh_type +
                        "&start_time=" + _this.szhStartTime +
                        "&end_time=" + _this.szhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.gtype_item +
                        "&goods_name=" + _this.szh_goods_name +
                        "&admin_id=" + $.trim($(_this.$refs.szh_admin).val()) +
                        "&user_group_id=" + _this.szh_group_checkboxModel +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.szhExport_type1;
                } else if(_this.szh_type == '2') {
                    let export_fields = JSON.stringify(_this.szhExport_checkModel2);
                    window.location.href = Vue.ctUrl + "FinanceReport/giftReporttExport?" +
                        "type=" + _this.szh_type +
                        "&start_time=" + _this.szhStartTime +
                        "&end_time=" + _this.szhEndTime +
                        "&shop_id=" + shop_id +
                        "&goods_type=" + _this.gtype_item +
                        "&goods_name=" + _this.szh_goods_name +
                        "&admin_id=" + $.trim($(_this.$refs.szh_admin).val()) +
                        "&user_group_id=" + _this.szh_group_checkboxModel +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.szhExport_type2;
                }
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 切换统计列表
            szhListType: function(num) {
                this.szh_type = num;
                if(num == '1') {
                    $('.szh-man').addClass('btn-orange');
                    $('.szh-cmdy').removeClass('btn-orange');
                } else if(num == '2') {
                    $('.szh-cmdy').addClass('btn-orange');
                    $('.szh-man').removeClass('btn-orange');
                    $(this.$refs.szh_admin).val('').trigger('change');
                }
                this.innitSzhTable();
            },
        }
    }
</script>
<style lang="less" scoped>
    .szh-list {
        .pull-right {
            button {
                margin-left: 10px;
            }
        }
    }
    /* 组别 */
    .szh-group {
        display: none;
        .group-search {
            position: relative;
            margin: 0 0 30px;
            input {
                width: 300px;
                height: 36px;
                padding: 0 45px 0 16px;
                color: #888;
                font-size: 16px;
                background: #f5f5f5;
                border-radius: 6px;
            }
            img {
                position: absolute;
                right: 10px;
                top: 6px;
                width: 24px;
                cursor: pointer;
            }
            button {
                margin: 0 30px 0 0;
            }
        }
        .group-list {
            clear: both;
            li:first-child {
                width: 100%;
                input {
                    margin: 2px 10px 0 0;
                }
            }
            li {
                float: left;
                width: 20%;
                margin: 0 0 30px;
                font-size: 14px;
                input {
                    float: left;
                    margin: 2px 10px 0 30px;
                }
                label {
                    margin: 0;
                    font-weight: normal;
                }
            }
        }
        .row {
            button {
                margin: 0 30px 0 0;
            }
        }
    }
</style>